import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent, IconComponent } from '@ui';

@Component({
  selector: 'sbnb-back-button-icon',
  standalone: true,
  imports: [IconComponent, ButtonComponent],
  templateUrl: './back-button-icon.component.html',
  styleUrl: './back-button-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackButtonIconComponent {
  @Input() disableRedirect = false;
  @Output() backClicked = new EventEmitter<void>();

  constructor(private location: Location) {}

  goBack() {
    this.backClicked.emit();

    if (!this.disableRedirect) {
      this.location.back();
    }
  }
}
